import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { PermissionsService } from "../services/permissions.service";
import { HttpErrorResponse } from "@angular/common/http";
import { throwError, BehaviorSubject } from "rxjs";
import {
  catchError,
  switchMap,
  filter,
  take,
  finalize,
  tap,
} from "rxjs/operators";
import { AuthenticationService } from "../services/auth.service";
import { Errors } from "../models/errorsCode";
import { MessagesService } from "src/app/shared/services/messages.service";
import { NgbModal, NgbOffcanvas } from "@ng-bootstrap/ng-bootstrap";
import { EventService } from "../services/event.service";
import { reserved } from "../models/reservedWord";
import { Router } from "@angular/router";
import { AppRoutes } from "src/app/shared/app/routers/appRouters";
import { environment } from "src/environments/environment";
import { IBaseResponse } from "src/app/shared/app/models/App/IBaseResponse";
import { MsalTokenService } from "../services/msal-token.service";

@Injectable()
export class PermissionsInterceptor implements HttpInterceptor {
  private isRefreshing: boolean = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null,
  );

  constructor(
    private auth: AuthenticationService,
    private perm: PermissionsService,
    private message: MessagesService,
    private modalService: NgbModal,
    private canvas: NgbOffcanvas,
    private eventService: EventService,
    private router: Router,
    private msalService: MsalTokenService,
  ) {}
  errors = [
    Errors.RefreshExpired,
    Errors.InvalidRefresh,
    Errors.RefreshRevoked,
    Errors.RefeshTokenDonstMatch,
    Errors.InvalidAccessToken,
  ];
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (request.method === "POST") this.nullableValues(request);

    let currentUser = this.auth.currentToken;
    if (currentUser) request = this.addHeaders(request, currentUser);
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error && error.status === Errors.TokenExpired)
          return this.handle701Error(request, next).pipe(
            catchError((err) => this.secondaryErrorHandler(err)),
          );
        // else if (error && error.status === Errors.MS_TokenExpiration) {
        //   return this.handle801Error(request, next);
        // }
        else if (this.errors.includes(error.status)) this.reusableMessage();
        else if (error.status === Errors.Error401)
          this.message.popup("Oops!", error.error.message, "error");
        else if (error.status === Errors.Error500)
          this.message.errMsgAndEmailSender(error);
        else if (error.status === Errors.NotExistFiles)
          this.secondaryErrorHandler(error);
        else if (error.status === Errors.ValidationError)
          this.secondaryErrorHandler(error);
        else if (error.status === Errors.Error302) {
        } else {
          this.message.errMsgAndEmailSender(error);
          let errorMessage = "An unknown error occurred.";

          if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
          } else {
            // server-side error
            errorMessage = error?.error?.message || errorMessage;
          }
          // this.message.popup("Oops!", errorMessage, "error");
        }
        this.eventService.broadcast(reserved.isLoading, false);
        return throwError(error.message);
      }),
    );
  }

  private nullableValues(request: HttpRequest<any>) {
    if (request.body !== null) {
      Object.keys(request.body).map((key) => {
        if (
          !request.body[key] &&
          typeof request.body[key] !== "number" &&
          typeof request.body[key] !== "boolean"
        )
          request.body[key] = "";
      });
    }
  }

  private addHeaders(request: HttpRequest<any>, token: string) {
    let currentMT = this.auth.currentMTToken || "";
    let header = {
      Authorization: `Bearer ${token}`,
      "ng-version": environment.appVersion,
      "Connect-To": this.auth.decodeToken.DbConnection!,
      "MT-Token": currentMT,
    };

    return request.clone({
      setHeaders: header,
    });
  }

  private handle701Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      return this.perm.refreshToken().pipe(
        switchMap((token: any) => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(token.data.accessToken);
          return next.handle(this.addHeaders(request, token.data.accessToken));
        }),
        finalize(() => (this.isRefreshing = false)),
      );
    } else
      return this.refreshTokenSubject.pipe(
        filter((token) => token !== null),
        take(1),
        switchMap((token) => next.handle(this.addHeaders(request, token))),
      );
  }

  private secondaryErrorHandler(error: HttpErrorResponse) {
    if (error.status === Errors.ValidationError) {
      let err = error.error as IBaseResponse<any>;
      let msg = "";
      if (err.validationErrors!.length) {
        for (let i = 0; i < err.validationErrors!.length; i++)
          msg += `<li class='text-start'>
              ${err.validationErrors![i].description}
          </li>`;
        this.message.templateComfirmation(
          err.message!,
          `<ul>${msg}</ul>`,
          "Ok!",
          "primary",
          "error",
        );
      }
    } else if (error.status === Errors.NotExistFiles) {
      this.message.popup("Attention!", error.error.message, "warning");
      this.modalService.dismissAll();
      this.canvas.dismiss();
      if (this.router.url.includes("update")) {
        let base = this.router.url.split("/");
        this.router.navigate([base[0] ? base[0] : base[1]]);
      }
    }
    this.eventService.broadcast(reserved.isLoading, false);
    return throwError(error);
  }

  private reusableMessage() {
    this.modalService.dismissAll();
    this.canvas.dismiss();
    this.eventService.broadcast(reserved.isLoading, false);
    return this.message
      .timerPopup("Attention!", "You Need To Relogin")
      .then(() => {
        this.auth.logout();
        this.router.navigate([AppRoutes.Auth.login], {
          queryParams: { returnUrl: this.router.routerState.snapshot.url },
        });
      });
  }
}
